export enum PROFILE_SETTING_KEYS {
  PREFERRED_LANGUAGE_CULTURE = "PreferredLanguageCulture",
}
